import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Question from "./Question.js";
import CustomLoader from "../static/CustomLoader.js";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const QuestionListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [questions, setQustions] = useState([]);
  const [parent, setParent] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [density, setDensity] = useState("standard");
  const [showConfirm, setShowConfirm] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const columns = [
    {
      field: "chapterName",
      headerName: "Chapter",
      flex: 4,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "question",
      headerName: "Question",
      flex: 6,
      headerAlign: "center",
      align: "center",
    },
  ];

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const fetchChapters = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${apiUrl}chapter`, { headers });

      const data = response.data;

      if (data.cd === 1) {
        toast.error(data.description || "Failed to fetch Chapters");
        setChapterData([]);
      } else {
        const sectionOption = data.map((op) => ({
          value: op.code,
          label: op.name,
        }));

        setChapterData(sectionOption);
        fetchData(sectionOption);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (ChapterData) => {
    try {
      setLoading(true);

      const response = await axios.get(apiUrl + "question", { headers });

      const enrichedData = response.data.map((item) => {
        const matchedStatus = ChapterData.find(
          (sku) => sku.value === item.chaptercode,
        );

        return {
          ...item,
          chapterName: matchedStatus ? matchedStatus.label : item.chaptercode,
        };
      });

      setQustions(enrichedData);
      setFilterData(enrichedData);

      const parentOption = response.data.map((op) => ({
        value: op.code,
        label: op.question,
      }));

      setParent(parentOption);
      setRefresh(false);
      setSelectedData([]);
    } catch (error) {
      console.log("error " + error);
      setQustions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChapters();
  }, [refresh]);

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );

      setQustions(searchdata);
    } else {
      setQustions(filterData);
    }

    setSerach(getSearch);
  };

  const RemoveFunction = async () => {
    if (selectedData) {
      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          setLoading(true);

          try {
            await axios
              .delete(apiUrl + "question/" + selectedData[0], { headers })
              .then((response) => {
                toast.success("Record removed successfully.");
                setLoading(false);
                fetchData(chapterData);
              });
          } catch (error) {
            console.error("Error deleting record:", error);
            setLoading(false);
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  const expectedHeaders = ["id", "code", "question", "chaptercode", "parent"];

  const exportToExcel = (data, filename = "Questions.xlsx") => {
    const ws = XLSX.utils.json_to_sheet(data, {
      header: expectedHeaders,
    });

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(file, filename);
  };

  const importFromExcel = (file, onValidData, onError) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const wb = XLSX.read(e.target.result, {
        type: "binary",
      });

      const sheet = wb.Sheets[wb.SheetNames[0]];

      const json = XLSX.utils.sheet_to_json(sheet, {
        defval: "",
      });

      const headers1 = Object.keys(json[0] || {});

      const isValid = expectedHeaders.every((h) => headers1.includes(h));

      if (!isValid) {
        onError("Invalid Excel Format. Please use the correct column headers.");
      } else {
        onValidData(json);
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleSubmitWithImportedData = async (importedData) => {
    if (importedData.length > 0) {
      setLoading(true);

      try {
        const transformedData = importedData.map((item) => ({
          ...item,
          id: 0,
          code: 0,
        }));

        const response = await axios.post(
          apiUrl + "question/multipleSave",
          transformedData,
          { headers },
        );

        if (response.data.cd === 1) {
          toast.warning("Failed to Import Data.");
          setRefresh(true);
        } else {
          toast.success("Imported data saved successfully.");
          setRefresh(true);
        }
      } catch (error) {
        console.error("Error during import:", error);
        toast.error("Error during import.");
      } finally {
        setLoading(false);
      }
    } else {
      toast.warning("No data to import.");
    }
  };

  const handleExcelImport = (event) => {
    const file = event.target.files[0];

    if (file) {
      importFromExcel(
        file,
        (validData) => {
          handleSubmitWithImportedData(validData);
          toast.success("Valid Excel file imported.");
        },
        (errorMsg) => {
          toast.error(errorMsg);
        },
      );
    }

    event.target.value = null;
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Question"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Question"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Delete Selected Question"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Export Questions to Excel"
                onClick={() => exportToExcel(questions)}
                disabled={loading}
              >
                Export
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Import Questions from Excel"
                component="label"
                icon={<UploadFileOutlinedIcon />}
                disabled={loading}
              >
                Import Data
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  hidden
                  onChange={handleExcelImport}
                />
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            questions !== null &&
            questions.length > 0 &&
            Object.keys(questions[0]).length !== 0 &&
            questions
          }
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Question"
        maxWidth="md"
      >
        <Question
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          chapterData={chapterData}
          parentData={parent}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Question"
        maxWidth="md"
      >
        <Question
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          chapterData={chapterData}
          parentData={parent}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default QuestionListing;
